var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("phone-edit"),
      _c(
        "ui-input",
        {
          ref: "base-mail",
          staticClass: "profile-contacts__input",
          attrs: {
            value: _vm.ACCOUNT.email,
            readonly: "",
            label: "Email*",
            error: _vm.mailError
          },
          scopedSlots: _vm._u([
            {
              key: "after",
              fn: function() {
                return [
                  _vm.NEED_TO_CONFIRM_NEW
                    ? _c(
                        "div",
                        { staticClass: "profile-contacts__input-info" },
                        [
                          _vm._v(
                            "\n        Email остаётся действующим, пока не подтверждён новый\n      "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm.ACCOUNT.email &&
                  !_vm.IS_EMAIL_CONFIRMED &&
                  !_vm.NEED_TO_CONFIRM_NEW
                    ? _c(
                        "span",
                        {
                          staticClass: "profile-contacts__resend base",
                          on: {
                            click: function($event) {
                              return _vm.resendEmail(_vm.ACCOUNT.email)
                            }
                          }
                        },
                        [_vm._v("\n        Отправить письмо повторно\n      ")]
                      )
                    : _vm._e()
                ]
              },
              proxy: true
            }
          ])
        },
        [
          !_vm.NEED_TO_CONFIRM_NEW
            ? _c(
                "div",
                {
                  staticClass: "edit-icon",
                  attrs: { slot: "append" },
                  on: {
                    click: function($event) {
                      _vm.isEmailEditOpened = true
                    }
                  },
                  slot: "append"
                },
                [
                  _c("f-sprite-icon", {
                    attrs: { "icon-link": _vm.$options.icons.IconEdit.id }
                  })
                ],
                1
              )
            : _vm._e()
        ]
      ),
      _vm.NEED_TO_CONFIRM_NEW
        ? [
            _c(
              "ui-input",
              {
                ref: "new-email",
                staticClass: "profile-contacts__input",
                attrs: {
                  value: _vm.UNCONFIRMED_EMAIL,
                  readonly: "",
                  label: "Новый Email",
                  error: _vm.newMailError
                },
                scopedSlots: _vm._u(
                  [
                    _vm.NEED_TO_CONFIRM_NEW
                      ? {
                          key: "after",
                          fn: function() {
                            return [
                              _c(
                                "span",
                                {
                                  staticClass: "profile-contacts__resend new",
                                  on: {
                                    click: function($event) {
                                      return _vm.resendEmail(
                                        _vm.UNCONFIRMED_EMAIL
                                      )
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n          Отправить письмо повторно\n        "
                                  )
                                ]
                              )
                            ]
                          },
                          proxy: true
                        }
                      : null
                  ],
                  null,
                  true
                )
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "edit-icon",
                    attrs: { slot: "append" },
                    on: {
                      click: function($event) {
                        _vm.isEmailEditOpened = true
                      }
                    },
                    slot: "append"
                  },
                  [
                    _c("f-sprite-icon", {
                      attrs: { "icon-link": _vm.$options.icons.IconEdit.id }
                    })
                  ],
                  1
                )
              ]
            )
          ]
        : _vm._e(),
      _c(
        "modal",
        {
          attrs: { visible: _vm.isEmailEditOpened },
          on: { "on-close": _vm.onClose }
        },
        [
          _c(
            "transition",
            { attrs: { name: "fade", mode: "out-in" } },
            [
              _vm.formShown
                ? _c("email-edit-form", {
                    on: { "email-confirmation": _vm.onEmailConfirmation }
                  })
                : _c("page-info", {
                    staticClass: "profile-contacts__confirm-info",
                    attrs: {
                      title: "Подтвердите изменение Email",
                      subtitle:
                        "Письмо для подтверждения нового Email  отправлено. Пожалуйста, проверьте почтовый ящик и перейдите по ссылке из письма."
                    }
                  })
            ],
            1
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }